import useLastReadActivityKey from './druid/providers/ActivityAcknowledgement/useLastReadActivityKey';

export default useLastReadActivityKey;
